define('lq/events/actions/languageCommand',[
    'jquery',
    'lq/events/actions/eventAction',
    'lq/runtimeUrl'
], function ($, EventAction, RuntimeUrl) {
    'use strict';

    function LanguageCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(LanguageCommand, EventAction);

    LanguageCommand.typeName = 'LanguageCommand';

    LanguageCommand.prototype.getBatchType = function () {
        return this.eventData.refreshPage
            ? EventAction.DO_NOT_BATCH
            : EventAction.COMMAND_BATCH;
    };

    LanguageCommand.prototype.createEventActionRequest = function () {
        return {
            eventActionType: 'SwitchLanguage',
            commandId: this.eventData.command
        };
    };

    LanguageCommand.prototype.execute = function (continuation, eventActionResponse) {
        if (eventActionResponse.queryString)
            this.piping.url.overwriteLicquidParameter(RuntimeUrl.parameters.language, eventActionResponse.queryString);
        this.refreshPageOrContinueEvents(continuation, eventActionResponse);
        this.piping.parameters.systems.setValue('CurrentLanguage', eventActionResponse.languageCode);
    };

    LanguageCommand.prototype.refreshPageOrContinueEvents = function (continuationFunc, eventActionResponse) {
        if (!eventActionResponse.refreshPage)
            continuationFunc();
        else {
            var params = $.extend({}, this.piping.queryString.getParameters());
            document.location.href = this.piping.url.prepare('', params);
        }
    };

    return LanguageCommand;
});
